import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dGlobalClassificationTranslations() {
  return {
    blendIntensity: {
      text: $localize`:@@scan3dGlobalClassification.blendIntensity:Blend Intensity`,
      desc: 'Label for the switch to show the point cloud with classification and blended intensity coloring.',
      limit: 30,
    },
  } satisfies TranslationMap;
}
